import _ from 'underscore';
import { Plugin } from '@trello/graphql/generated';
import TrelloMarkdown from '@atlassian/trello-markdown';
import {
  getIndex,
  getNameIndex,
} from '@trello/app/src/components/Navigation/SearchUtils';
import { Plugins } from './types';

export const createSearchIndex = (plugins: Plugins) => {
  const markdown = new TrelloMarkdown();

  getNameIndex.init();
  getIndex.init();

  plugins.forEach((plugin) => {
    if (!plugin.listing) {
      return;
    }
    if (plugin.listing.name) {
      getNameIndex.add(plugin.id, plugin.listing.name);
    }
    if (plugin.listing.description || plugin.listing.overview) {
      const body = [
        markdown.text(plugin.listing.overview || '').output,
        markdown.text(plugin.listing.description || '').output,
      ].join(' ');
      getIndex.add(plugin.id, body);
    }
  });

  return {
    search(query: string): Plugin[] {
      const nameResults = getNameIndex.search(query, 5);
      const bodyResults = getIndex.search(query, 25);
      return _.uniq(nameResults.concat(bodyResults)).map(
        (idPlugin: string) =>
          plugins.find((plugin) => plugin.id === idPlugin) as Plugin,
      );
    },
  };
};

export const SearchHelper = {
  createSearchIndex,
};
